import { FaSquareXTwitter } from "react-icons/fa6";
import ScrollTopButton from "../ScrollTopButton/ScrollTopButton";
import "./Footer.css";
import { FaFacebookSquare, FaInstagramSquare, FaYoutubeSquare } from "react-icons/fa";

export default function Footer() {
  return (
    <>
      <footer className="footer">
        {/* Left Column - Contact Us */}
        {/* <div className="footer-col">
        <h3>Contact Us</h3>
        <p>📍 Location</p>
        <p>📞 +91 9999999999</p>
        <p>📧 connect@domemarketing.in</p>
      </div> */}

        {/* Center Column - Branding */}
        <div className="footer-col footer-center">
          <h2 className="footer-title">Al Muntazar TV</h2>
          <p>
            Fill in your details and submit. We will send you daily Hadith, Tamseel short clips, and event updates on WhatsApp. Additionally, we will share our magazine with you via email
          </p>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/almuntazartv/"
              target="_blank"
              rel="noopener noreferrer"
              className="icon instagram"
            >
              <FaInstagramSquare />
            </a>


            <a
              href="https://www.facebook.com/AlmuntazarTV/"
              target="_blank"
              rel="noopener noreferrer"
              className="icon facebook"
            >
              <FaFacebookSquare />
            </a>

            <a
              href="https://x.com/AlMuntazarTV"
              target="_blank"
              rel="noopener noreferrer"
              className="icon twitter"
            >
              <FaSquareXTwitter />
            </a>

            <a
              href="https://www.youtube.com/@AlMuntazarTV"
              target="_blank"
              rel="noopener noreferrer"
              className="icon youtube"
            >
              <FaYoutubeSquare />
            </a>
          </div>
          <div className="social-icons">
            <button
              className="subscribe-btn"
              onClick={() =>
                window.open("https://www.youtube.com/@AlMuntazarTV", "_blank")
              }
            >
              Subscribe Our YT
            </button>
          </div>
          {/* <p className="footer-bottom">
          © 2025 Al Muntazar TV. All rights reserved.
        </p> */}
        </div>

        {/* Right Column - Opening Hours */}
        {/* <div className="footer-col">
        <h3>Opening Hours</h3>
        <p>Everyday</p>
        <p>10.00 AM – 10.00 PM</p>
      </div> */}

        {/* WhatsApp floating button */}
      </footer>
      <a
        href="https://api.whatsapp.com/send?phone=919372809411&text=Salam&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-link"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          className="whatsapp-icon"
        />
      </a>
      <ScrollTopButton threshold={window.innerHeight * 0.6} />
    </>
  );
}
